export default __webpack_public_path__ + "static/media/480_business06-jp-mobile.5a1329f0.png";